import { type ObjectValuesUnionType } from '../../utils/typing';

export const SearchActionTypes = Object.freeze({
  CLEAR_SEARCH: 'search/clear',
  SET_SEARCH_LOADING: 'search/setLoading',
  SET_SEARCH_QUERY: 'search/query',
});

export type SearchActionType = ObjectValuesUnionType<typeof SearchActionTypes>;
